import {
  saveReferral,
  fetchReferral,
  deleteReferral,
  fetchReferralSyncRecords,
  apiFetchLabraReferralStatusHistory,
} from '../../../../oppsync/api/CoSell'
import { fetchPartnerObject } from '../../../../common/api'
import {
  ReferralFormSectionName,
  ReferralOppSections,
  PartialReferralObject,
  CustomerDetails,
  ProjectDetails,
  AwsDetails,
  LabraReferralStatusHistory,
  LabraReferralStatus,
  ReferralOppSectionFields,
  ProductListType,
  offerData,
} from './reducer'
import { AppDispatch, RootState } from '../../../../store'
import {
  PartnerCentralUsers,
  Referral,
  ReferralAPI,
  ReferralMetadata,
  ReferralObject,
} from '../reducer.ts'
import {
  startLoading,
  stopLoading,
} from '../../../../common/modules/loading/actions.ts'
import { LoadingTypes } from '../../../../common/modules/loading/reducer.ts'
import { errorLogger } from '../../../../common/utils/errorLogger.ts'
import { updateAppAlert } from '../../../../common/modules/appAlert/actions.ts'
import {
  RequestFailureMessage,
  cosellDefaultFieldsError,
} from '../../../../common/utils/messagesContants.ts'
import { getErrorMessages } from '../../../../common/utils/error.ts'
import { AxiosError, AxiosResponse } from 'axios'
import { autoSave } from '../../../../common/modules/autoSave/actions.ts'
import {
  APIReferralError,
  parseReferralAPIError,
  formatErrorMessagesForAlert,
  filterErrorsForNonExistentFormikFields,
} from '../../../../externalApps/api/errorHandlers.ts'
import {
  mapLeadApiToLead,
  mapReferralApiToReferral,
  removeEmptyValues,
} from '../../../../common/utils/CoSellHelpers/helperFunctions.ts'
import { isEmpty } from 'lodash'
import { camelize } from 'casing'
import { PartnerType } from '../../../../common/modules/partner/action.ts'
import { ReferralMetadataType, ReferralUpdatedBy } from '../types.ts'
import { ActionType } from '../../../../externalApps/modules/referrals/actions.ts'
import { ReferralStage, SyncRecord } from '../../../components/CoSell/types.ts'
import { ReferralSyncStatus } from '../reducer.ts'
import {
  PartialLeadObject,
  ReferralLeadSections,
} from '../LeadsReferralForm/types.ts'
import { CosellReferralType } from '../actions.ts'
import { CloudType } from '../../../../common/modules/types'
import {
  setAzureCreationData,
  setAzureDetails,
  setAzureFormFieldErrors,
  mapAzureApiToForm,
} from '../AzureReferralForm/actions.ts'
import {
  mapLeadApiToForm,
  setLeadCreationData,
  setLeadDetails,
  setLeadFormFieldErrors,
  submitLeadForm,
} from '../LeadsReferralForm/actions.ts'
import { submitAzureForm } from '../AzureReferralForm/actions.ts'
import { capitalizeFirstLetter } from '../../../../common/utils/helperFunctions.ts'
import { isHubSpotContext } from '../../../../common/utils/appContext.ts'
import { FormikErrors } from 'formik'
import { getReferredBy } from '../../../../externalApps/modules/customForm/actions.ts'
import {
  fetchPrivateOffersList,
  fetchPrivateOffersValidation,
  fetchProductsList,
} from '../../../api/index.ts'
import {
  saveReferral as saveSalesforceReferral,
  SaveReferralAPIParams,
  acceptReferral,
  rejectReferral,
} from '../../../api/CoSell/index.new.ts'
import { fetchReferral as fetchReferralAPI } from '../../../api/CoSell/index.new.ts'
import { canvasAuthService } from '../../../../common/services/CanvasAuthService'
import {
  getPartnerIdFromState,
  getTenantPartnerIdFromState,
} from '../../../../common/utils/Hooks/usePartnerData'
import { isAdminRole } from '../../../../common/utils/isAdminRole'
//import { ProjectDetails } from '../../../components/CoSell/ReferralForm/ProjectDetailsForm/ProjectDetails/ProjectDetails.tsx'
export enum ReferralFormActions {
  SET_REFERRAL_FORM = 'SET_REFERRAL_FORM',
  UPDATE_REFERRAL_FORM = 'UPDATE_REFERRAL_FORM',
  SET_PRODUCTS_LIST = 'SET_PRODUCTS_LIST',
  SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT',
  SET_PRIVATE_OFFERS_LIST = 'SET_PRIVATE_OFFERS_LIST',
  SET_SELECTED_PRIVATE_OFFER = 'SET_SELECTED_PRIVATE_OFFER',
  SET_LINKED_PRIVATE_OFFER_DATA = 'SET_LINKED_PRIVATE_OFFER_DATA',
  SET_REFERRAL = 'SET_REFERRAL',
  SET_FORM_REFERRAL_ERRORS = 'SET_FORM_REFERRAL_ERRORS',
  CLEAR_REFERRAL_FORM = 'CLEAR_REFERRAL_FORM',
  SET_LEAD_FORM = 'SET_LEAD_FORM',
  SET_LEAD = 'SET_LEAD',
  SET_NEXT_STEP_INPUT_MESSAGE = 'SET_NEXT_STEP_INPUT_MESSAGE',
  SET_LABRA_REFERRAL_STATUS_HISTORY = 'SET_LABRA_REFERRAL_STATUS_HISTORY',
  ADD_LABRA_REFERRAL_STATUS_HISTORY = 'ADD_LABRA_REFERRAL_STATUS_HISTORY',
}

export const setReferralCreationData = (
  onboardingFormData: Partial<ReferralOppSections>
) => ({
  type: ReferralFormActions.SET_REFERRAL_FORM,
  payload: onboardingFormData,
})

export const setSelectedProduct = (selectedProduct: string) => ({
  type: ReferralFormActions.SET_SELECTED_PRODUCT,
  payload: selectedProduct,
})

export const setProductListData = (productsData: ProductListType[]) => ({
  type: ReferralFormActions.SET_PRODUCTS_LIST,
  payload: productsData,
})

export const setSelectedPrivateOffer = (
  selectedPrivateOfferId: string,
  selectedPrivateOfferName: string
) => ({
  type: ReferralFormActions.SET_SELECTED_PRIVATE_OFFER,
  payload: {
    selectedPrivateOfferId,
    selectedPrivateOfferName,
  },
})

export const setPrivateOffersData = (privateOffersData: ProductListType[]) => ({
  type: ReferralFormActions.SET_PRIVATE_OFFERS_LIST,
  payload: privateOffersData,
})

export const setOffersData = (offersData: offerData) => ({
  type: ReferralFormActions.SET_LINKED_PRIVATE_OFFER_DATA,
  payload: offersData,
})

export const setNextStepInputMessage = (message: string) => ({
  type: ReferralFormActions.SET_NEXT_STEP_INPUT_MESSAGE,
  payload: message,
})

export const clearReferralForm = () => ({
  type: ReferralFormActions.CLEAR_REFERRAL_FORM,
})

export type ReferralChangeType = {
  sectionName: ReferralFormSectionName
  data: Partial<CustomerDetails> | Partial<ProjectDetails> | Partial<AwsDetails>
}

export const setReferralDetails = (referral: PartialReferralObject) => ({
  type: ReferralFormActions.SET_REFERRAL,
  payload: referral,
})

export const updateReferralCreationData = (data: ReferralChangeType) => ({
  type: ReferralFormActions.UPDATE_REFERRAL_FORM,
  payload: data,
})

export const emptyReferralFormFieldErrors = {} as Record<keyof Referral, string>

export const setFormFieldErrors = (errors: Record<keyof Referral, string>) => ({
  type: ReferralFormActions.SET_FORM_REFERRAL_ERRORS,
  payload: errors,
})

export const addLabraReferralStatusHistory = (
  status: LabraReferralStatus,
  now = new Date().toISOString()
) => ({
  type: ReferralFormActions.ADD_LABRA_REFERRAL_STATUS_HISTORY,
  payload: {
    status,
    updated_at: now,
  },
})

export const submitReferralFormForAutosave =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    supportMultiCloudForHubspot?: boolean
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    // Check if we're in Salesforce context for autosave too
    //const isSalesforce = isSalesforceContext(getState)

    try {
      // Get the latest referralId from state to avoid race conditions
      // This ensures we always use the most up-to-date referralId after previous autosaves
      const state = getState()
      const latestReferralId =
        referralId ||
        state.referralFormCreation.referral?.referralMetadata?.referralId

      const submitFn =
        isInHubspotContext && supportMultiCloudForHubspot
          ? _submitMultiCloudHubspotReferralForm
          : isInHubspotContext
            ? _submitReferralForm
            : _submitSalesforceReferralForm

      dispatch(
        autoSave('coSellReferralForm', () =>
          dispatch(submitFn(referral, status, latestReferralId))
        )
      )
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    }
  }

export const submitReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    referralType: CosellReferralType = 'opportunity',
    templateId?: string,
    cloudType: CloudType = CloudType.AWS,
    /** When true (e.g. `cosellMappingManagerMultiCloudSupport` flag), HubSpot uses Salesforce-style multi-cloud submit. */
    supportMultiCloudForHubspot?: boolean
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.COSELL))

    // Get appropriate functions based on referral type and cloud type
    const { submitFn, setErrorsAction, mapApiToRef } = getSubmitFunctions(
      referralType,
      cloudType,
      supportMultiCloudForHubspot
    )
    try {
      const result = await dispatch(
        submitFn(referral, status, referralId, actionType, templateId)
      )
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      if (result && result.error) throw result.error
      dispatch(
        updateAppAlert({
          message:
            status === 'draft'
              ? 'Referral was successfully saved as draft.'
              : 'Referral was successfully submitted.',
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
      dispatch(setNextStepInputMessage(''))
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      const errorResponse = error.response?.data

      if (errorResponse) {
        try {
          const parsedErrors = parseReferralAPIError(errorResponse)
          const parsedErrorsTransformed = mapApiToRef(parsedErrors)
          const globalState = getState()

          // Get the form structure to check if fields exist in formik form
          let referralFormObject: Record<string, object> | undefined
          if (referralType === 'lead') {
            referralFormObject = globalState.leadReferralForm?.referralForm as
              | Record<string, object>
              | undefined
          } else {
            // For opportunity and Azure, the form structure is directly in referralFormCreation.referralForm
            referralFormObject = globalState.referralFormCreation
              ?.referralForm as unknown as Record<string, object> | undefined
          }

          // Always set field errors - formik will handle fields that exist
          if (!isEmpty(parsedErrorsTransformed)) {
            dispatch(setErrorsAction(parsedErrorsTransformed as any)) // forcing any here to comply with Referral & ReferralLead type, but this could be handled by moving this error handling function outside and having 2 branches with different types, like with generics
          }

          // Filter errors: only show in alert those that don't exist in the formik form
          // Uses optimized function with field caching for fast lookups
          const errorsNotInForm = filterErrorsForNonExistentFormikFields(
            parsedErrors,
            parsedErrorsTransformed as Record<string, unknown>,
            referralFormObject
          )

          // Get specific error messages only for fields not in the formik form
          const specificErrorMessage =
            formatErrorMessagesForAlert(errorsNotInForm)

          if (specificErrorMessage) {
            // Show the specific error message(s) from the API for fields not in formik form
            dispatch(
              updateAppAlert({
                message: specificErrorMessage,
                messageType: 'ERROR',
                autoClose: false,
              })
            )
          } else if (!isEmpty(parsedErrorsTransformed)) {
            // All errors are shown in formik form fields, show generic message
            dispatch(
              updateAppAlert({
                message: cosellDefaultFieldsError,
                messageType: 'ERROR',
                autoClose: false,
              })
            )
          } else {
            // No specific errors, show generic failure message
            dispatch(
              updateAppAlert({
                message: getErrorMessages([RequestFailureMessage])(
                  e.response as AxiosResponse<ErrorResponse>
                ),
                messageType: 'ERROR',
                autoClose: false,
              })
            )
          }
        } catch (e) {
          console.error('Error while parsing the response payload', e)
          const globalState = getState()
          errorLogger({ globalState })(error as Error)
        }
      } else {
        dispatch(
          updateAppAlert({
            message: getErrorMessages([RequestFailureMessage])(
              e.response as AxiosResponse<ErrorResponse>
            ),
            messageType: 'ERROR',
            autoClose: false,
          })
        )
      }

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      dispatch(stopLoading(LoadingTypes.COSELL))
    }
  }

const _submitReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    templateId?: string
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const partnerData = getState().AccountData.user.partnerData
    const stage =
      getState().referralFormCreation.referralForm.projectDetails.stage

    const referralMetadataReferralFormCreation =
      getState().referralFormCreation.referral?.referralMetadata

    const referralMetadataCustomForm =
      getState().customForm.hubspotForm.customData?.referralMetadata
    // const partnerCentralUsersEmailCosell =
    //  getState().cosell.oppsync.partnerCentralUsers || []
    const partnerCentralUsersEmail =
      getState().customForm.hubspotForm.customData?.partnerCentralUsers || []
    const referralFromBackend =
      getState().referralFormCreation.referral?.referralObject
    const { acceptanceStatus, rejectionReason, nextStep, nextStepHistory } =
      getState().referralFormCreation.referralForm.projectDetails
    const { offerId } = getState().referralFormCreation.referralForm.awsDetails
    const objectCrmId =
      getState().referralFormCreation.referral?.referralObject?.Id
    const referredBy =
      getState().referralFormCreation.referral?.referralObjectTransformed
        ?.referredBy
    const extraData = {
      stage,
      acceptanceStatus,
      rejectionReason,
      nextStep,
      nextStepHistory,
      offerId,
    }
    const dataTransformToApiFormat = referralFormToAPI(
      {
        ...referral,
        extra: extraData,
      },
      objectCrmId
    )

    const dataWithoutEmptyValues = removeEmptyValues(dataTransformToApiFormat)

    const partnerUserSelected = partnerCentralUsersEmail.filter(
      p =>
        p.email ===
        referral[ReferralFormSectionName.PROJECT_DETAILS]?.opportunityOwnerEmail
    )[0]

    const partnerCentralUserName = `${capitalizeFirstLetter(
      partnerUserSelected?.first_name
    )} ${capitalizeFirstLetter(partnerUserSelected?.last_name)}`

    const referralFromForm = dataWithoutEmptyValues
    const referralPayload: Partial<ReferralAPI> = {
      ...referralFromBackend,
      ...Object.fromEntries(
        Object.entries(referralFromForm).filter(
          ([key, value]) => value !== '' && value !== undefined
        )
      ),
      Labra__Referred_By__c: referredBy || 'Partner Referral',
      Labra__Last_Updated_By__c: ReferralUpdatedBy.LABRA_CRM,
      Labra__AWS_Partner_Central_User_Name__c: partnerCentralUserName,
    }

    const referralMetadata =
      referralMetadataReferralFormCreation ||
      camelize(referralMetadataCustomForm)
    const partnerDataFromCrm =
      getState().customForm.hubspotForm.customData?.labraSettingObject
    const saveReferralParams = {
      referralObject: referralPayload,
      invokeSync: status === 'submitted',
      referralMetadata: {
        ...referralMetadata,
        crmId: referralMetadata?.crmId || partnerData?.crmId || '',
        referralType: 'referral_opportunity' as ReferralMetadataType,
        referralStatus: status,
        crmParentTable: 'labra_referral',
        crmPrimaryKeyName: 'id',
      },
      labraSettingObject: {
        consultingPartner: false,
        technologyPartner: false,
        isv: (partnerData?.isIsv || partnerDataFromCrm?.isv) ?? false,
        srrp: (partnerData?.isSrrp || partnerDataFromCrm?.srrp) ?? false,
        accelerateProgram:
          (partnerData?.accelerateProgram ||
            partnerDataFromCrm?.accelerate_program) ??
          false,
        awsFieldsVersion:
          partnerData?.awsFieldsVersion ||
          partnerDataFromCrm?.aws_fields_version ||
          'v14',
      },
    }

    try {
      const { data } = await saveReferral(
        saveReferralParams,
        referralId,
        actionType,
        templateId
      )

      const { referral_id: newReferralId, object_crm_id: objectCrmId } = data
      const lastReferralId = referralId ? referralId : newReferralId
      // save status history beforehand to prevent race condition
      // where component will try to fetch the data right after the
      // setReferralDetails
      await dispatch(
        addLabraReferralStatusHistory(
          status === 'submitted'
            ? LabraReferralStatus.SUBMITTED
            : LabraReferralStatus.DRAFT
        )
      )
      await dispatch(
        setReferralDetails({
          referralMetadata: {
            ...saveReferralParams.referralMetadata,
            ...(!isEmpty(lastReferralId) && { referralId: newReferralId }),
            ...(!isEmpty(objectCrmId) && {
              crmPrimaryKeyValue: objectCrmId,
            }),
            createdAt:
              saveReferralParams.referralMetadata.createdAt ||
              new Date().toISOString(),
          },
          referralObject: {
            ...referralPayload,
            ...(!isEmpty(lastReferralId) && { Id: objectCrmId }),
          },
        })
      )
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      // intentionally returning error because redux does not bubble up the error
      return { error: e }
    }
  }

// Salesforce-specific referral submission function
// Uses different API endpoint and request body structure than Hubspot/Oppsync
const _submitSalesforceReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    templateId?: string
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const partnerData = getState().AccountData.user.partnerData
    const stage =
      getState().referralFormCreation.referralForm.projectDetails.stage ??
      getState().referralFormCreation.referralForm.extra?.stage ??
      'Prospect'

    const referralMetadataReferralFormCreation =
      getState().referralFormCreation.referral?.referralMetadata

    const referralMetadataCustomForm =
      getState().customForm.hubspotForm.customData?.referralMetadata

    const partnerCentralUsersEmail =
      getState().customForm.hubspotForm.customData?.partnerCentralUsers || []
    const referralFromBackend =
      getState().referralFormCreation.referral?.referralObject
    const { acceptanceStatus, rejectionReason, nextStep, nextStepHistory } =
      getState().referralFormCreation.referralForm.projectDetails
    const { offerId } = getState().referralFormCreation.referralForm.awsDetails
    const objectCrmId =
      getState().referralFormCreation.referral?.referralObject?.Id
    const referredBy =
      getState().referralFormCreation.referral?.referralObjectTransformed
        ?.referredBy

    // Salesforce-specific extraData construction (modify as needed)
    const extraData = {
      stage,
      acceptanceStatus,
      rejectionReason,
      nextStep,
      nextStepHistory,
      offerId,
      // Add Salesforce-specific fields here if needed
    }

    const dataTransformToApiFormat = referralFormToAPI(
      {
        ...referral,
        extra: extraData,
      },
      objectCrmId
    )

    const dataWithoutEmptyValues = removeEmptyValues(dataTransformToApiFormat)

    const partnerUserSelected = partnerCentralUsersEmail.filter(
      p =>
        p.email ===
        referral[ReferralFormSectionName.PROJECT_DETAILS]?.opportunityOwnerEmail
    )[0]

    const partnerCentralUserName = `${capitalizeFirstLetter(
      partnerUserSelected?.first_name
    )} ${capitalizeFirstLetter(partnerUserSelected?.last_name)}`

    const referralFromForm = dataWithoutEmptyValues
    const filteredEntries = Object.entries(referralFromForm).filter(
      ([key, value]) => value !== '' && value !== undefined
    )

    const referralPayload: Partial<ReferralAPI> = {
      ...referralFromBackend,
      ...Object.fromEntries(filteredEntries),
      Labra__Referred_By__c: referredBy || 'Partner Referral',
      Labra__Last_Updated_By__c: ReferralUpdatedBy.LABRA_CRM,
      Labra__AWS_Partner_Central_User_Name__c: partnerCentralUserName,
    }
    const referralMetadata =
      referralMetadataReferralFormCreation ||
      camelize(referralMetadataCustomForm)
    const partnerDataFromCrm =
      getState().customForm.hubspotForm.customData?.labraSettingObject

    // Get account_id - try AWS account ID first, then fallback to partnerId or empty string
    const awsAccountId =
      getState().referralFormCreation.referralForm.awsDetails?.awsAccountId
    const accountId = awsAccountId || partnerData?.partnerId || ''

    // Get partnerId for endpoint
    const partnerId = partnerData?.partnerId

    // Get parent_object_id from Salesforce record
    const parentOpportunityId = canvasAuthService.getRecord()?.recordId || ''

    // Salesforce-specific request body structure matching the new API format
    // When updating (actionType === 'patch'), don't include form_status if it's already submitted
    // Backend doesn't allow updating form_status when it's already submitted
    const currentFormStatus = (getState().referralFormCreation.referral as any)
      ?.form_status
    const referralMetadataStatus =
      referralMetadataReferralFormCreation?.referralStatus ||
      (referralMetadataCustomForm as any)?.referral_status

    // Determine if form_status should be included:
    // - Always include for create (!actionType)
    // - Never include for updates when current status is 'submitted' (backend restriction)
    // - Include for updates only if current status is NOT 'submitted'
    const isUpdatingSubmittedReferral =
      (actionType === 'patch' || actionType === 'put') &&
      (currentFormStatus === 'submitted' ||
        referralMetadataStatus === 'submitted')
    const shouldIncludeFormStatus = !actionType || !isUpdatingSubmittedReferral

    // Build params object conditionally to ensure form_status is not included when updating submitted referrals
    const baseParams = {
      object_type: 'opportunity' as const,
      //referred_by: referredBy || 'Partner Referral',
      referred_by: 'partner',
      labra_referral: referralPayload, // All Salesforce fields go here
      crm_object_id: objectCrmId || undefined, // Optional: CRM object ID for updates
      cloud_object_id: undefined, // Optional: Cloud object ID
      parent_object_id: parentOpportunityId || undefined, // Optional: Parent opportunity ID

      cloud_type: 'AWS' as const,
      account_id: accountId, // Required: Account UUID
    }

    // Only add form_status if allowed (not updating submitted referrals)
    const saveReferralParams: SaveReferralAPIParams = shouldIncludeFormStatus
      ? {
          ...baseParams,
          form_status: status as 'draft' | 'submitted',
        }
      : {
          ...baseParams,
        }
    const isAcceptRejectPatch =
      actionType === 'patch' &&
      referralId &&
      partnerId &&
      (acceptanceStatus === 'Accepted' || acceptanceStatus === 'Rejected')

    if (isAcceptRejectPatch) {
      try {
        if (acceptanceStatus === 'Accepted') {
          await acceptReferral(partnerId, referralId)
        } else {
          await rejectReferral(partnerId, referralId, {
            labra_referral: {
              Labra__Rejection_reason__c: rejectionReason ?? '',
            },
          })
        }
        await dispatch(
          addLabraReferralStatusHistory(
            acceptanceStatus === 'Accepted'
              ? LabraReferralStatus.ACCEPTED
              : LabraReferralStatus.REJECTED
          )
        )
        const formStatusFromApi = 'submitted'
        const updatedReferralMetadata = {
          ...referralMetadata,
          crmId: referralMetadata?.crmId || partnerData?.crmId || '',
          referralType: 'referral_opportunity' as ReferralMetadataType,
          referralStatus: status,
          crmParentTable: 'labra_referral',
          crmPrimaryKeyName: 'id',
          ...(referralId && !isEmpty(referralId) && { referralId }),
          ...(!isEmpty(objectCrmId) && {
            crmPrimaryKeyValue: objectCrmId,
          }),
          createdAt: referralMetadata?.createdAt || new Date().toISOString(),
        }
        await dispatch(
          setReferralDetails({
            referralMetadata: updatedReferralMetadata,
            referralObject: {
              ...referralPayload,
              ...(referralId && { Id: objectCrmId }),
            },
            form_status: formStatusFromApi,
          })
        )
        return
      } catch (e: any) {
        const error = e as AxiosError<APIReferralError>
        const globalState = getState()
        errorLogger({ globalState })(error as Error)
        return { error: e }
      }
    }

    try {
      // Use Salesforce-specific API function
      const { data } = await saveSalesforceReferral(
        saveReferralParams,
        referralId,
        actionType,
        templateId,
        partnerId
      )

      // Handle response - adjust field names based on actual API response structure
      const newReferralId = data.referral_id || data.id || referralId
      const responseCrmObjectId =
        data.object_crm_id || data.crm_object_id || objectCrmId
      const lastReferralId = referralId ? referralId : newReferralId
      // Get form_status from API response (it's at the top level of the response)
      const formStatusFromApi = data.form_status || status

      await dispatch(
        addLabraReferralStatusHistory(
          status === 'submitted'
            ? LabraReferralStatus.SUBMITTED
            : LabraReferralStatus.DRAFT
        )
      )

      // Update referral metadata for state management
      // Always set referralId if newReferralId exists (from API response)
      // This ensures referralId is stored in state after creation, preventing duplicate referrals
      const updatedReferralMetadata = {
        ...referralMetadata,
        crmId: referralMetadata?.crmId || partnerData?.crmId || '',
        referralType: 'referral_opportunity' as ReferralMetadataType,
        referralStatus: status,
        crmParentTable: 'labra_referral',
        crmPrimaryKeyName: 'id',
        ...(newReferralId &&
          !isEmpty(newReferralId) && { referralId: newReferralId }),
        ...(!isEmpty(responseCrmObjectId) && {
          crmPrimaryKeyValue: responseCrmObjectId,
        }),
        createdAt: referralMetadata?.createdAt || new Date().toISOString(),
      }

      await dispatch(
        setReferralDetails({
          referralMetadata: updatedReferralMetadata,
          referralObject: {
            ...referralPayload,
            ...(!isEmpty(lastReferralId) && { Id: responseCrmObjectId }),
          },
          // Store form_status from API response at the top level of referral object
          form_status: formStatusFromApi,
        })
      )
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return { error: e }
    }
  }

/** Partner/account UUID for Salesforce engine APIs when HubSpot multi-cloud is on: CloudAccountChangeV2 selection + URL rules, then AccountData. */
const getPartnerIdForHubspotMultiCloudThunk = (
  getState: () => RootState
): string => {
  const state = getState()
  const pathname =
    typeof window !== 'undefined' && window.location?.pathname
      ? window.location.pathname
      : ''
  const partnerType = isAdminRole(state.userProfile.userProfile)
    ? PartnerType.Admin
    : PartnerType.User
  return (
    getPartnerIdFromState(state, pathname, partnerType) ||
    state.AccountData[partnerType]?.partnerData?.partnerId ||
    ''
  )
}

const _submitMultiCloudHubspotReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    templateId?: string
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState()
    const partnerData = state.AccountData.user.partnerData
    const selectedPartnerAccountId =
      getPartnerIdForHubspotMultiCloudThunk(getState)
    const stage = state.referralFormCreation.referralForm.projectDetails.stage

    const referralMetadataReferralFormCreation =
      state.referralFormCreation.referral?.referralMetadata

    const referralMetadataCustomForm =
      state.customForm.hubspotForm.customData?.referralMetadata
    // const partnerCentralUsersEmailCosell =
    //  getState().cosell.oppsync.partnerCentralUsers || []
    const partnerCentralUsersEmail =
      state.customForm.hubspotForm.customData?.partnerCentralUsers || []
    const referralFromBackend =
      state.referralFormCreation.referral?.referralObject
    const { acceptanceStatus, rejectionReason, nextStep, nextStepHistory } =
      state.referralFormCreation.referralForm.projectDetails
    const { offerId } = state.referralFormCreation.referralForm.awsDetails
    const objectCrmId = state.referralFormCreation.referral?.referralObject?.Id
    const referredBy =
      state.referralFormCreation.referral?.referralObjectTransformed?.referredBy
    const extraData = {
      stage,
      acceptanceStatus,
      rejectionReason,
      nextStep,
      nextStepHistory,
      offerId,
    }
    const dataTransformToApiFormat = referralFormToAPI(
      {
        ...referral,
        extra: extraData,
      },
      objectCrmId
    )

    const dataWithoutEmptyValues = removeEmptyValues(dataTransformToApiFormat)

    const partnerUserSelected = partnerCentralUsersEmail.filter(
      p =>
        p.email ===
        referral[ReferralFormSectionName.PROJECT_DETAILS]?.opportunityOwnerEmail
    )[0]

    const partnerCentralUserName = `${capitalizeFirstLetter(
      partnerUserSelected?.first_name
    )} ${capitalizeFirstLetter(partnerUserSelected?.last_name)}`

    const referralFromForm = dataWithoutEmptyValues
    const referralPayload: Partial<ReferralAPI> = {
      ...referralFromBackend,
      ...Object.fromEntries(
        Object.entries(referralFromForm).filter(
          ([key, value]) => value !== '' && value !== undefined
        )
      ),
      Labra__Referred_By__c: referredBy || 'Partner Referral',
      Labra__Last_Updated_By__c: ReferralUpdatedBy.LABRA_CRM,
      Labra__AWS_Partner_Central_User_Name__c: partnerCentralUserName,
    }

    const referralMetadata =
      referralMetadataReferralFormCreation ||
      camelize(referralMetadataCustomForm)

    const awsAccountId =
      state.referralFormCreation.referralForm.awsDetails?.awsAccountId
    const accountId =
      awsAccountId || selectedPartnerAccountId || partnerData?.partnerId || ''
    const partnerId =
      selectedPartnerAccountId || partnerData?.partnerId || undefined
    const parentOpportunityId = canvasAuthService.getRecord()?.recordId || ''

    const currentFormStatus = (state.referralFormCreation.referral as any)
      ?.form_status
    const referralMetadataStatus =
      referralMetadataReferralFormCreation?.referralStatus ||
      (referralMetadataCustomForm as any)?.referral_status

    const isUpdatingSubmittedReferral =
      (actionType === 'patch' || actionType === 'put') &&
      (currentFormStatus === 'submitted' ||
        referralMetadataStatus === 'submitted')
    const shouldIncludeFormStatus = !actionType || !isUpdatingSubmittedReferral

    const baseParams = {
      object_type: 'opportunity' as const,
      referred_by: 'partner',
      labra_referral: referralPayload,
      crm_object_id: objectCrmId || undefined,
      cloud_object_id: undefined,
      parent_object_id: parentOpportunityId || undefined,
      cloud_type: 'AWS' as const,
      account_id: accountId,
    }

    const saveReferralParams: SaveReferralAPIParams = shouldIncludeFormStatus
      ? {
          ...baseParams,
          form_status: status as 'draft' | 'submitted',
        }
      : {
          ...baseParams,
        }

    const isAcceptRejectPatch =
      actionType === 'patch' &&
      referralId &&
      partnerId &&
      (acceptanceStatus === 'Accepted' || acceptanceStatus === 'Rejected')

    if (isAcceptRejectPatch) {
      try {
        if (acceptanceStatus === 'Accepted') {
          await acceptReferral(partnerId, referralId)
        } else {
          await rejectReferral(partnerId, referralId, {
            labra_referral: {
              Labra__Rejection_reason__c: rejectionReason ?? '',
            },
          })
        }
        await dispatch(
          addLabraReferralStatusHistory(
            acceptanceStatus === 'Accepted'
              ? LabraReferralStatus.ACCEPTED
              : LabraReferralStatus.REJECTED
          )
        )
        const formStatusFromApi = 'submitted'
        const updatedReferralMetadata = {
          ...referralMetadata,
          crmId: referralMetadata?.crmId || partnerData?.crmId || '',
          referralType: 'referral_opportunity' as ReferralMetadataType,
          referralStatus: status,
          crmParentTable: 'labra_referral',
          crmPrimaryKeyName: 'id',
          ...(referralId && !isEmpty(referralId) && { referralId }),
          ...(!isEmpty(objectCrmId) && {
            crmPrimaryKeyValue: objectCrmId,
          }),
          createdAt: referralMetadata?.createdAt || new Date().toISOString(),
          ...(partnerId && !isEmpty(partnerId) && { partner_id: partnerId }),
        }
        await dispatch(
          setReferralDetails({
            referralMetadata: updatedReferralMetadata,
            referralObject: {
              ...referralPayload,
              ...(referralId && { Id: objectCrmId }),
            },
            form_status: formStatusFromApi,
          })
        )
        return
      } catch (e: any) {
        const error = e as AxiosError<APIReferralError>
        const globalState = getState()
        errorLogger({ globalState })(error as Error)
        return { error: e }
      }
    }

    try {
      const { data } = await saveSalesforceReferral(
        saveReferralParams,
        referralId,
        actionType,
        templateId,
        partnerId
      )

      const newReferralId = data.referral_id || data.id || referralId
      const responseCrmObjectId =
        data.object_crm_id || data.crm_object_id || objectCrmId
      const lastReferralId = referralId ? referralId : newReferralId
      const formStatusFromApi = data.form_status || status

      await dispatch(
        addLabraReferralStatusHistory(
          status === 'submitted'
            ? LabraReferralStatus.SUBMITTED
            : LabraReferralStatus.DRAFT
        )
      )

      const updatedReferralMetadata = {
        ...referralMetadata,
        crmId: referralMetadata?.crmId || partnerData?.crmId || '',
        referralType: 'referral_opportunity' as ReferralMetadataType,
        referralStatus: status,
        crmParentTable: 'labra_referral',
        crmPrimaryKeyName: 'id',
        ...(newReferralId &&
          !isEmpty(newReferralId) && { referralId: newReferralId }),
        ...(!isEmpty(responseCrmObjectId) && {
          crmPrimaryKeyValue: responseCrmObjectId,
        }),
        createdAt: referralMetadata?.createdAt || new Date().toISOString(),
        ...(partnerId && !isEmpty(partnerId) && { partner_id: partnerId }),
      }

      await dispatch(
        setReferralDetails({
          referralMetadata: updatedReferralMetadata,
          referralObject: {
            ...referralPayload,
            ...(!isEmpty(lastReferralId) && { Id: responseCrmObjectId }),
          },
          form_status: formStatusFromApi,
        })
      )
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return { error: e }
    }
  }

const referralFormToAPI = (
  values: Partial<ReferralOppSections>,
  objectCrmId?: string
): Partial<ReferralAPI> => {
  const {
    customerDetails,
    contacts,
    projectDetails,
    awsDetails,
    saasDocumentation,
    awsContactsDetails,
    extra,
  } = values

  return {
    Id: objectCrmId,
    Name: projectDetails?.partnerProjectTitle,
    Labra__IsOppFromMarketingActivity__c: projectDetails?.isThisFromMarketing,
    Labra__Labra_ACE_CRM_Lead_UniqueIdentifier__c: '',
    Labra__apnReviewerComments__c: '',
    Labra__Sync_to_AWS__c: true,
    Labra__awsSFCampaignName__c: projectDetails?.marketingCampaignCode,
    Labra__Offer_ID__c: extra?.offerId ?? null,
    Labra__Other_Solution_Offered__c: projectDetails?.otherSolutionOffered,
    Labra__Parent_Opportunity_ID__c: projectDetails?.parentOpportunityId,
    Labra__Partner_Contact_Title__c: contacts?.partnerSalesContactTitle,
    Labra__AWS_Recommended_Action__c: awsDetails?.recommendedNextBestActions,
    Labra__AWS_Marketplace_Engagement_Score__c: awsDetails?.engagementScore,
    Labra__APN_CRM_Unique_Identifier__c: '',
    Labra__AWS_Account_Id__c: awsDetails?.awsAccountId,
    Labra__Campaign_Name__c: awsDetails?.apnProgram?.join(';'),
    Labra__AWS_Account_Owner_Email__c:
      awsContactsDetails?.awsAccountManagerEmail,
    Labra__AWS_Account_Owner_Name__c: awsContactsDetails?.awsAccountManagerName,
    Labra__AWS_Internal_Stage__c: '',
    Labra__AWS_Partner_Central_User_Email__c:
      projectDetails?.opportunityOwnerEmail,
    Labra__AWS_Partner_Central_User_Name__c:
      projectDetails?.opportunityOwnerName,
    Labra__AWS_Sales_Rep_Email__c: awsContactsDetails?.awsSalesRepEmail,
    Labra__AWS_Sales_Rep_Name__c: awsContactsDetails?.awsSalesRepName,
    Labra__City__c: customerDetails?.city,
    Labra__Company_Name__c: customerDetails?.companyName,
    Labra__Country__c: customerDetails?.country,
    Labra__Primary_Sales_Rep_Email__c: contacts?.partnerSalesContactEmail,
    Labra__Primary_Sales_Rep_First_Name__c: contacts?.partnerContactFirstName,
    Labra__Primary_Sales_Rep_Last_Name__c: contacts?.partnerContactLastName,
    Labra__Primary_Sales_Rep_Phone__c: contacts?.partnerSalesContactPhone,
    Labra__Delivery_Model__c: projectDetails?.deliveryModel?.join(';'),
    Labra__Description__c: projectDetails?.customerBusinessProblem,
    Labra__Expected_Monthly_AWS_Revenue__c:
      projectDetails?.expectedMonthlyAwsRevenue,
    Labra__ISV_Manager_Email__c: awsContactsDetails?.awsIsvSuccessManagerEmail,
    Labra__ISV_Manager_Name__c: awsContactsDetails?.awsIsvSuccessManagerName,
    Labra__Industry__c: customerDetails?.industry,
    Labra__Next_Step_History__c: extra?.nextStepHistory,
    Labra__Next_step__c: extra?.nextStep,
    Labra__Sender_Company_Name__c: awsDetails?.senderCompanyName,
    Labra__Sender_Company_Domain__c: awsDetails?.senderCompanyDomain,
    Labra__Sender_Contact_Email__c: awsDetails?.senderContactEmail,
    Labra__Sender_Contact_First_Name__c: awsDetails?.senderContactFirstName,
    Labra__Sender_Contact_Last_Name__c: awsDetails?.senderContactLastName,
    Labra__Competitive_Tracking__c: awsDetails?.competitiveTracking,
    Labra__Other_Competitive_Tracking__c: awsDetails?.competitiveTrackingOther,
    Labra__Other_Industry__c: isEmpty(customerDetails?.otherIndustry)
      ? null
      : customerDetails?.otherIndustry,
    Labra__Other_PDM_Email__c: awsContactsDetails?.wwpsPdmEmail,
    Labra__Other_PDM__c: awsContactsDetails?.wwpsPdm,
    Labra__PDM_Email__c: awsContactsDetails?.pdmEmail,
    Labra__PDM__c: awsContactsDetails?.pdmName,
    Labra__Postal_Code__c: customerDetails?.postalCode
      ? customerDetails.postalCode.toString()
      : '',
    Labra__Primary_Need_From_AWS_MultiSelect__c:
      projectDetails?.partnerPrimaryNeedFromAws?.join(';'),

    Labra__State__c: customerDetails?.state,
    Labra__Street_Address__c: customerDetails?.streetAddress,
    Labra__Success_Manager_Email__c: awsContactsDetails?.psmEmail,
    Labra__Success_Manager_Name__c: awsContactsDetails?.psmName,
    Labra__Use_Case__c: projectDetails?.useCase,
    Labra__Website__c: customerDetails?.website,
    Labra__Target_Close_Date__c: projectDetails?.targetCloseDate,
    Labra__Solution_offered__c: projectDetails?.solutionOffered?.join(';'),
    Labra__Opportunity_Type__c: projectDetails?.opportunityType,
    Labra__Sales_Activities__c: projectDetails?.salesActivities?.join(';'),
    Labra__Customer_DUNS__c: customerDetails?.duns,
    Labra__AWS_products__c: awsDetails?.awsProducts?.join(';'),
    Labra__Referral_Stage__c: extra?.stage || '',
    Labra__Rejection_reason__c: extra?.rejectionReason || '',
    Labra__Acceptance_Status__c: extra?.acceptanceStatus || 'Accepted',
    Labra__AWS_Closed_Lost_Reason__c: awsDetails?.closedReason,
    Labra__AWS_Closed_Lost_Reason_Code__c: '',
    Labra__Has_classified_NatSec_Information__c:
      customerDetails?.hasClassifiedNationalSecurityInformation,
    Labra__Additional_Comments__c: projectDetails?.additionalComments,
    Labra__AWS_Close_Date__c: awsDetails?.awsCloseDate,
    Labra__contractStartDate__c: saasDocumentation?.contractEffectiveDate,
    Labra__contractEndDate__c: saasDocumentation?.contractExpirationDate,
    Labra__customerSoftwareValueCurrency__c: saasDocumentation?.currency,
    Labra__customerSoftwareValue__c:
      saasDocumentation?.customerSoftwareValue || null,
    Labra__procurementType__c: saasDocumentation?.procurementType,
    Labra__Customer_Email__c: customerDetails?.email,
    Labra__Customer_First_Name__c: customerDetails?.firstName,
    Labra__Customer_Last_Name__c: customerDetails?.lastName,
    Labra__Customer_Phone__c: customerDetails?.phone,
    Labra__Customer_Title__c: customerDetails?.title,
    Labra__marketingActivityChannel__c:
      projectDetails?.marketingActivityChannel === null
        ? null
        : projectDetails?.marketingActivityChannel?.join(';'),
    Labra__marketingActivityUsecase__c:
      projectDetails?.marketingActivityUseCase === null
        ? null
        : projectDetails?.marketingActivityUseCase?.join(';'),
    Labra__MDF_Needed__c: projectDetails?.marketingFundsUsed,
    Labra__Referred_By__c: projectDetails?.referredBy,
  }
}
export const referralAPIToForm = (
  values: Partial<ReferralAPI>
): RecursivePartial<ReferralOppSections> => {
  // Helper to convert null to empty string for string fields
  // This ensures form validation works the same way as creating from scratch
  const nullToEmpty = (value: string | null | undefined): string | undefined =>
    value === null ? '' : value

  // Helper to process an object and apply nullToEmpty to all string values
  const processStringFields = <T extends Record<string, any>>(obj: T): T => {
    const processed = { ...obj }
    for (const key in processed) {
      const value = processed[key]
      if (typeof value === 'string' || value === null || value === undefined) {
        processed[key] = nullToEmpty(value) as any
      }
    }
    return processed
  }

  const result = {
    customerDetails: {
      companyName: values.Labra__Company_Name__c,
      country: values.Labra__Country__c,
      industry: values.Labra__Industry__c,
      otherIndustry: values.Labra__Other_Industry__c,
      website: values.Labra__Website__c,
      city: values.Labra__City__c,
      duns: values.Labra__Customer_DUNS__c,
      postalCode: values.Labra__Postal_Code__c,
      state: values.Labra__State__c,
      streetAddress: values.Labra__Street_Address__c,
      firstName: values.Labra__Customer_First_Name__c,
      lastName: values.Labra__Customer_Last_Name__c,
      email: values.Labra__Customer_Email__c,
      phone: values.Labra__Customer_Phone__c,
      title: values.Labra__Customer_Title__c,
      hasClassifiedNationalSecurityInformation:
        values.Labra__Has_classified_NatSec_Information__c,
    },
    projectDetails: {
      customerBusinessProblem: values.Labra__Description__c,
      deliveryModel: values.Labra__Delivery_Model__c?.split(';'),
      isThisFromMarketing: values.Labra__IsOppFromMarketingActivity__c,
      marketingFundsUsed: values.Labra__MDF_Needed__c,
      parentOpportunityId: values.Labra__Parent_Opportunity_ID__c,
      opportunityOwnerEmail: values.Labra__AWS_Partner_Central_User_Email__c,
      opportunityOwnerName: values.Labra__AWS_Partner_Central_User_Name__c,
      opportunityType: values.Labra__Opportunity_Type__c,
      partnerPrimaryNeedFromAws:
        values.Labra__Primary_Need_From_AWS_MultiSelect__c
          ? values.Labra__Primary_Need_From_AWS_MultiSelect__c.split(';')
          : [],
      partnerProjectTitle: values.Name,
      salesActivities: values.Labra__Sales_Activities__c
        ? values.Labra__Sales_Activities__c.split(';')
        : [],
      solutionOffered: values.Labra__Solution_offered__c
        ? values.Labra__Solution_offered__c.split(';')
        : [],
      otherSolutionOffered: values.Labra__Other_Solution_Offered__c,
      targetCloseDate: values.Labra__Target_Close_Date__c,
      useCase: values.Labra__Use_Case__c,
      expectedMonthlyAwsRevenue:
        values.Labra__Expected_Monthly_AWS_Revenue__c === null
          ? undefined
          : values.Labra__Expected_Monthly_AWS_Revenue__c,
      marketingActivityChannel:
        values.Labra__marketingActivityChannel__c?.split(';'),
      marketingActivityUseCase:
        values.Labra__marketingActivityUsecase__c?.split(';'),
      marketingCampaignCode: values.Labra__awsSFCampaignName__c,
      referredBy: values.Labra__Referred_By__c,
      additionalComments: values.Labra__Additional_Comments__c,
    },
    contacts: {
      partnerContactFirstName: values.Labra__Primary_Sales_Rep_First_Name__c,
      partnerContactLastName: values.Labra__Primary_Sales_Rep_Last_Name__c,
      partnerSalesContactEmail: values.Labra__Primary_Sales_Rep_Email__c,
      partnerSalesContactPhone: values.Labra__Primary_Sales_Rep_Phone__c,
      partnerSalesContactTitle: values.Labra__Partner_Contact_Title__c,
    },
    awsDetails: {
      apnProgram: values.Labra__Campaign_Name__c
        ? values.Labra__Campaign_Name__c.split(';')
        : [],
      awsProducts: values.Labra__AWS_products__c
        ? values.Labra__AWS_products__c.split(';')
        : [],
      awsAccountId: values.Labra__AWS_Account_Id__c,
      offerId: values.Labra__Offer_ID__c,
      senderCompanyName: values.Labra__Sender_Company_Name__c,
      senderCompanyDomain: values.Labra__Sender_Company_Domain__c,
      senderContactEmail: values.Labra__Sender_Contact_Email__c,
      senderContactFirstName: values.Labra__Sender_Contact_First_Name__c,
      senderContactLastName: values.Labra__Sender_Contact_Last_Name__c,
      competitiveTracking: values.Labra__Competitive_Tracking__c,
      competitiveTrackingOther: values.Labra__Other_Competitive_Tracking__c,
      closedReason: values.Labra__AWS_Closed_Lost_Reason__c,
      awsClosedReason: values.Labra__AWS_Closed_Lost_Reason_Code__c,
      awsCloseDate: values.Labra__AWS_Close_Date__c,
      engagementScore: values.Labra__AWS_Marketplace_Engagement_Score__c,
      recommendedNextBestActions: values.Labra__AWS_Recommended_Action__c,
      customerSegment: values?.Labra__Customer_Segment__c,
      isGreenfield: values?.Labra__isGreenfield__c,
    },
    saasDocumentation: {
      contractEffectiveDate: values.Labra__contractStartDate__c,
      contractExpirationDate: values.Labra__contractEndDate__c,
      currency: values.Labra__customerSoftwareValueCurrency__c,
      customerSoftwareValue: values.Labra__customerSoftwareValue__c,
      procurementType: values.Labra__procurementType__c,
    },
    awsContactsDetails: {
      awsAccountManagerEmail: values.Labra__AWS_Account_Owner_Email__c,
      awsAccountManagerName: values.Labra__AWS_Account_Owner_Name__c,
      awsSalesRepEmail: values.Labra__AWS_Sales_Rep_Email__c,
      awsSalesRepName: values.Labra__AWS_Sales_Rep_Name__c,
      awsIsvSuccessManagerEmail: values.Labra__ISV_Manager_Email__c,
      awsIsvSuccessManagerName: values.Labra__ISV_Manager_Name__c,
      psmEmail: values.Labra__Success_Manager_Email__c,
      psmName: values.Labra__Success_Manager_Name__c,
      pdmEmail: values.Labra__PDM_Email__c,
      pdmName: values.Labra__PDM__c,
      wwpsPdmEmail: values.Labra__Other_PDM_Email__c,
      wwpsPdm: values.Labra__Other_PDM__c,
    },
    extra: {
      stage: values.Labra__Referral_Stage__c as ReferralStage,
      acceptanceStatus: values.Labra__Acceptance_Status__c,
      rejectionReason: values.Labra__Rejection_reason__c,
      nextStep: values.Labra__Next_step__c,
      nextStepHistory: values.Labra__Next_Step_History__c,
      offerId: values.Labra__Offer_ID__c,
    },
  }

  // Apply nullToEmpty to string fields in sections that need it
  return {
    customerDetails: processStringFields(result.customerDetails),
    projectDetails: processStringFields(result.projectDetails),
    contacts: processStringFields(result.contacts),
    awsDetails: result.awsDetails,
    saasDocumentation: result.saasDocumentation,
    awsContactsDetails: result.awsContactsDetails,
    extra: result.extra,
  }
}

export const formikErrorsToReferral = (
  errors: FormikErrors<ReferralOppSections>
): Record<string, string> => {
  const buffer = {} as Record<string, string>
  for (const key in errors) {
    const nestedErrors = errors[key as keyof ReferralOppSections] as
      | Record<string, string>
      | undefined
    if (nestedErrors) {
      for (const subKey in nestedErrors) {
        buffer[subKey as keyof Referral] = nestedErrors[subKey]
      }
    }
  }
  return buffer
}

const getReferralType = (referral: any): CosellReferralType => {
  if (referral?.referral_metadata?.referral_type === 'referral_lead') {
    return 'lead'
  }
  return 'opportunity'
}

interface ReferralActions {
  setReferralDetails:
    | typeof setReferralDetails
    | typeof setLeadDetails
    | typeof setAzureDetails
  setReferralCreationData:
    | typeof setReferralCreationData
    | typeof setLeadCreationData
    | typeof setAzureCreationData
  transform:
    | typeof referralAPIToForm
    | typeof mapLeadApiToForm
    | typeof mapAzureApiToForm
}

export const getReferralActions = (
  referralType: CosellReferralType,
  cloudType: CloudType = CloudType.AWS
): ReferralActions => {
  // If cloud is Azure, return Azure actions regardless of referral type
  if (cloudType === CloudType.AZURE) {
    return {
      setReferralDetails: setAzureDetails,
      setReferralCreationData: setAzureCreationData,
      transform: mapAzureApiToForm,
    }
  }

  // Default AWS flow
  switch (referralType) {
    case 'lead':
      return {
        setReferralDetails: setLeadDetails,
        setReferralCreationData: setLeadCreationData,
        transform: mapLeadApiToForm,
      }
    case 'opportunity':
      return {
        setReferralDetails: setReferralDetails,
        setReferralCreationData: setReferralCreationData,
        transform: referralAPIToForm,
      }
  }
}
// Helper to detect if we're in Salesforce context
/**
 * Helper function to check if we're running in Salesforce context
 * Uses canvasAuthService - matches the pattern from SidePanelWrapperV3:
 * salesforceContext.error !== 'salesforce_context_not_available'
 */
const isInSalesforceContext = (): boolean => {
  try {
    // Error condition 1: No valid partnerId
    const partnerId = canvasAuthService.getPartnerId()
    if (!partnerId || isEmpty(partnerId)) {
      return false
    }
    return true
  } catch {
    return false
  }
}

const isInHubspotContext = isHubSpotContext()

export const getSubmitFunctions = (
  referralType: CosellReferralType,
  cloudType: CloudType = CloudType.AWS,
  supportMultiCloudForHubspot?: boolean
) => {
  // If cloud is Azure, return Azure functions regardless of referral type
  if (cloudType === CloudType.AWS) {
    // Default AWS flow
    switch (referralType) {
      case 'lead':
        return {
          submitFn: submitLeadForm,
          setErrorsAction: setLeadFormFieldErrors,
          mapApiToRef: mapLeadApiToLead,
        }
      case 'opportunity': {
        const submitFn =
          isInHubspotContext && supportMultiCloudForHubspot
            ? _submitMultiCloudHubspotReferralForm
            : isInHubspotContext
              ? _submitReferralForm
              : _submitSalesforceReferralForm
        return {
          submitFn,
          setErrorsAction: setFormFieldErrors,
          mapApiToRef: mapReferralApiToReferral,
        }
      }
      default:
        const defaultSubmitFn =
          isInHubspotContext && !supportMultiCloudForHubspot
            ? _submitReferralForm
            : isInHubspotContext && supportMultiCloudForHubspot
              ? _submitMultiCloudHubspotReferralForm
              : _submitSalesforceReferralForm
        return {
          submitFn: defaultSubmitFn,
          setErrorsAction: setFormFieldErrors,
          mapApiToRef: mapReferralApiToReferral,
        }
    }
  }

  // Azure cloud flow
  if (cloudType === CloudType.AZURE) {
    return {
      submitFn: submitAzureForm,
      setErrorsAction: setAzureFormFieldErrors,
      mapApiToRef: mapAzureApiToForm,
    }
  }

  // Default to AWS opportunity for unknown cloud types
  return {
    submitFn: _submitReferralForm,
    setErrorsAction: setFormFieldErrors,
    mapApiToRef: mapReferralApiToReferral,
  }
}

export const getProductLists =
  (referralId: string, productType: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const { data } = await fetchProductsList(referralId, productType)

      const transformedData = data
        .map((item: any) => {
          let productTitle = ''
          switch (productType) {
            case 'AmiProduct':
              productTitle = item.AmiProductSummary?.ProductTitle || ''
              break
            case 'ContainerProduct':
              productTitle = item.ContainerProductSummary?.ProductTitle || ''
              break
            case 'SaaSProduct':
              productTitle = item.SaaSProductSummary?.ProductTitle || ''
              break
            case 'DataProduct':
              productTitle = item.DataProductSummary?.ProductTitle || ''
              break
          }
          return {
            entityId: item.EntityId,
            productTitle: productTitle,
          }
        })
        .filter((item: any) => item.productTitle)

      await dispatch(setProductListData(transformedData))
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    }
  }

export const getPrivateOffers =
  (referralId: string, productId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const { data } = await fetchPrivateOffersList(referralId, productId)
      const transformedData = data
        .map((item: any) => {
          return {
            entityId: item.EntityId,
            productTitle: item.OfferSummary?.Name || '',
          }
        })
        .filter((item: any) => item.productTitle)

      await dispatch(setPrivateOffersData(transformedData))
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    }
  }

export const getOffersValidations =
  (referralId: string, productId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(
      startLoading(LoadingTypes.FETCHING_LINKED_PRIVATE_OFFER_VALIDATIONS)
    )
    try {
      const { data } = await fetchPrivateOffersValidation(referralId, productId)
      const transformedData = {
        offerId: data.DetailsDocument.Id,
        offerName: data.DetailsDocument.Name,
        productId: data.DetailsDocument.ProductId,
      }

      await dispatch(setOffersData(transformedData))
      return true
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return false
    } finally {
      dispatch(
        stopLoading(LoadingTypes.FETCHING_LINKED_PRIVATE_OFFER_VALIDATIONS)
      )
    }
  }

export const getReferral =
  (
    referralId: string,
    partnerType: PartnerType,
    supportMultiCloudForHubspot?: boolean
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.COSELL_FETCH_REFERRAL))
    try {
      let referralData
      const isHubspotContextFound = isHubSpotContext()
      const pathname =
        typeof window !== 'undefined' && window.location?.pathname
          ? window.location.pathname
          : ''

      if (isHubspotContextFound && !supportMultiCloudForHubspot) {
        // Use CRM Service API endpoint
        const { data } = await fetchReferral(referralId)
        referralData = data
      } else {
        // Use AWS Engine Service API endpoint
        const state = getState()
        const tenantPartnerId =
          getTenantPartnerIdFromState(state, partnerType) || ''
        const partnerId =
          isHubspotContextFound && supportMultiCloudForHubspot
            ? getPartnerIdFromState(state, pathname, partnerType) ||
              tenantPartnerId
            : tenantPartnerId

        if (!partnerId || isEmpty(partnerId)) {
          throw new Error('PartnerId is required to fetch referral')
        }

        const { data } = await fetchReferralAPI(partnerId, referralId)

        // Transform Salesforce response structure to match expected format
        // Salesforce returns: { labra_referral: {...}, id, crm_id, ... }
        // Expected format: { referral_object: {...}, referral_metadata: {...} }
        const { labra_referral, ...rest } = data
        const metadataPartnerId =
          isHubspotContextFound && supportMultiCloudForHubspot
            ? partnerId || data.partner_id
            : data.partner_id
        referralData = {
          referral_object: labra_referral || {},
          referral_metadata: {
            referral_id: data.id || referralId,
            referral_type:
              data.object_type === 'lead'
                ? 'referral_lead'
                : 'referral_opportunity',
            referral_status: data.form_status || '',
            crm_id: data.crm_id,
            partner_id: metadataPartnerId,
            crmPrimaryKeyValue: data.id || referralId, // Set crmPrimaryKeyValue for ReferralStatusComponent
            ...rest,
          },
        }
      }

      const referralType = getReferralType(referralData)
      const actions = getReferralActions(referralType)

      if (!referralData?.referral_object) {
        throw new Error('referral_object is missing from referral data')
      }

      const referralObject = {
        ...referralData.referral_object,
        Labra__Referred_By__c: getReferredBy(
          referralData.referral_object.Labra__Referred_By__c
        ),
      }

      const transformedData = actions.transform(referralObject as any) as any

      await dispatch(actions.setReferralCreationData(transformedData))

      // Get partnerId for fetching sync records
      const partnerIdForSync =
        isHubSpotContext() && supportMultiCloudForHubspot
          ? getPartnerIdFromState(getState(), pathname, partnerType) ||
            referralData.referral_metadata?.partner_id ||
            getTenantPartnerIdFromState(getState(), partnerType) ||
            ''
          : referralData.referral_metadata?.partner_id ||
            getTenantPartnerIdFromState(getState(), partnerType) ||
            ''
      let referralSyncData: SyncRecord[] | null = null
      try {
        if (partnerIdForSync) {
          const isHubspotContext = isHubSpotContext()

          if (isHubspotContext && !supportMultiCloudForHubspot) {
            // HubSpot: backend already returns a consumable shape — just camelize and pass through
            const syncResponse = await fetchReferralSyncRecords(referralId)
            const responseData = syncResponse?.data ?? syncResponse ?? null
            referralSyncData = responseData
              ? (camelize(responseData) as any)
              : []
          } else {
            // Default (partner object): fetch and normalize sync_attempts into SyncRecord[]
            const syncResponse = await fetchPartnerObject(
              partnerIdForSync,
              referralId,
              'sync_attempts',
              'opportunity'
            )
            // The API response structure: { data: { sync_attempts: [...] } }
            // After camelization it becomes: { data: { syncAttempts: [...] } }
            const responseData = syncResponse.data || {}
            const camelizedData = camelize(responseData) as any

            // Transform SyncObjectType.syncAttempts to SyncRecord[] format
            // Handle both camelCase (syncAttempts) and snake_case (sync_attempts) formats
            const syncAttempts =
              camelizedData.syncAttempts ||
              camelizedData.sync_attempts ||
              responseData.sync_attempts ||
              []

            referralSyncData = syncAttempts.map(
              (attempt: any, index: number) => {
                // Use status field if available, otherwise map from resultJsonType/result_json_type
                let status: ReferralSyncStatus = 'in_progress'

                if (attempt.status === 'success') {
                  status = 'success'
                } else {
                  const resultType =
                    attempt.resultJsonType || attempt.result_json_type || ''
                  if (resultType === 'success') {
                    status = 'success'
                  } else if (resultType === 'error') {
                    status = 'error'
                  } else if (resultType === 'warning') {
                    status = 'warning'
                  } else if (resultType === 'in_progress') {
                    status = 'in_progress'
                  }
                }

                // Map direction ('ace' | 'crm') to syncDirection ('ace_to_crm' | 'crm_to_ace')
                const direction = attempt.direction || ''
                const syncDirection: 'ace_to_crm' | 'crm_to_ace' =
                  direction === 'ace' ? 'ace_to_crm' : 'crm_to_ace'

                // Get message from errorResolution/error_resolution or resultJson/result_json
                const rawMessage =
                  attempt.errorResolution ||
                  attempt.error_resolution ||
                  attempt.resultJson ||
                  attempt.result_json ||
                  ''

                // Clean up message - remove 'null' string and empty arrays
                let message = rawMessage
                if (
                  message === 'null' ||
                  message === '["null"]' ||
                  message === '[]'
                ) {
                  message = ''
                }

                return {
                  id:
                    attempt.syncId ||
                    attempt.sync_id ||
                    attempt.id ||
                    `sync-${index}`,
                  labraReferralId: referralId,
                  status,
                  message,
                  syncDirection,
                  createdAt: attempt.createdAt || attempt.created_at || '',
                  updatedAt: attempt.updatedAt || attempt.updated_at || '',
                }
              }
            )
          }
        }
      } catch (syncError) {
        console.warn(
          '[getReferral] Failed to fetch referral sync records (non-critical):',
          syncError
        )
        // Continue without sync records - this is not critical for rendering
      }

      const camelizedMetadata = camelize(referralData.referral_metadata) as any
      await dispatch(
        actions.setReferralDetails({
          referralMetadata: {
            ...camelizedMetadata,
            referralId: camelizedMetadata.referralId || referralId, // Ensure referralId is set
          },
          referralObject: referralObject,
          referralSyncs: referralSyncData || [],
        })
      )
      // Return the referral payload so callers can await dispatch(getReferral(...))
      return {
        referralMetadata: {
          ...camelizedMetadata,
          referralId: camelizedMetadata.referralId || referralId,
        },
        referralObject: referralObject,
        referralSyncs: referralSyncData || [],
      }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      dispatch(stopLoading(LoadingTypes.COSELL_FETCH_REFERRAL))
    }
  }

export const deleteDraftReferral =
  (referralId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.COSELL_DELETE_REFERRAL))

    try {
      await deleteReferral(referralId)

      return {
        sucess: true,
      }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return {
        sucess: false,
        error: error,
      }
    } finally {
      dispatch(stopLoading(LoadingTypes.COSELL_DELETE_REFERRAL))
    }
  }

export const setLabraReferralStatusHistory = (
  statusHistory: LabraReferralStatusHistory[]
) => ({
  type: ReferralFormActions.SET_LABRA_REFERRAL_STATUS_HISTORY,
  payload: statusHistory,
})

export const fetchLabraReferralStatusHistory =
  (partnerId: string, referralId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(
      startLoading(LoadingTypes.COSELL_FETCH_LABRA_REFERRAL_STATUS_HISTORY)
    )

    try {
      const {
        data: { status_history },
      } = await apiFetchLabraReferralStatusHistory(partnerId, referralId)

      dispatch(setLabraReferralStatusHistory(status_history))
    } catch (e: any) {
      dispatch(setLabraReferralStatusHistory([]))
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      dispatch(
        stopLoading(LoadingTypes.COSELL_FETCH_LABRA_REFERRAL_STATUS_HISTORY)
      )
    }
  }

export const setValidationErrors =
  (
    errors: FormikErrors<ReferralOppSections>,
    referralType: CosellReferralType
  ) =>
  (dispatch: AppDispatch) => {
    const setErrorsAction =
      referralType === 'opportunity'
        ? setFormFieldErrors
        : setLeadFormFieldErrors
    const referralErrors = formikErrorsToReferral(errors)
    dispatch(setErrorsAction(referralErrors as any))
  }
